import isEpicPlan from '../plan/isEpicPlan'
import isPlanPPO from '../plan/isPlanPPO'

/**
 * Filter out Epic PPO plans only on the DTC site.
 * @param isEnroll - Whether we are on the enroll.pivothealth.com (DTC) site.
 * @param epicPlans - The Epic plan IDs.
 * @param plansData - The Epic plan data.
 * @returns All plans that are not Epic PPO plans
 */
function filterEpicPlans<T extends CorePlan>(
  isEnroll: boolean,
  epicPlans: number[],
  plansData: { [planId: string]: T }
) {
  if (!isEnroll) return { filteredPlans: plansData, planIds: epicPlans }

  const planIds = epicPlans.filter(planId => {
    const plan = plansData[planId]
    return !isPlanPPO(plan)
  })

  const filteredPlans = {}
  Object.keys(plansData).forEach(planId => {
    const plan = plansData[planId]
    const isEpic = isEpicPlan(plan)

    if (!isEpic || (isEpic && !isPlanPPO(plan))) {
      filteredPlans[planId] = {
        ...plan
      }
    }
  })

  return { planIds, filteredPlans }
}

export default filterEpicPlans
